import styled, { withTheme } from 'styled-components';

import BaseButton from './base-button';
import plusIcon from '../../../assets/images/plus.svg';
import plusAltIcon from '../../../assets/images/plus-alt.svg';
import minusIcon from '../../../assets/images/minus.svg';


const ToolNavButton = styled(BaseButton)`
    &.btn {
        &.btn-primary, &.btn-primary:focus, &.btn-primary:active {
            padding:9px 35px 9px 15px !important;
            transform: none;
            border-radius:0;
            display:block;
            width:100%;
            text-align: left;
            outline:none !important;
            box-shadow:none !important;
            border:thin solid transparent;
            color: ${props => props.theme.$dark};
            font-family: ${props => props.theme['$font-family-sans-serif']} !important;
            font-size: ${(props) => props.theme['$font-size-14']};
            text-transform: none !important;
            font-weight: 400 !important;
            background: transparent;
            border: 1px solid ${props => props.theme.$gold};
            padding-right:40px;
            white-space:normal;
            position:relative;
            .icon {
                position:absolute;
                top:8px;
                right:8px;
                width:20px;
                height:20px;
                display:inline-block;
                background: url(${plusIcon}) no-repeat top left;
                background-size: 20px 20px;
                margin:0 0 0 5px;
            }
            &.active, &:hover {
                transform: none;
                border: 1px solid ${props => props.theme.$gold};
                background-color: ${props => props.theme.$gold};
                color: ${props => props.theme.$white};
                .icon {
                    top:8px;
                    right:8px;
                    width:20px;
                    height:20px;
                    background: url(${plusAltIcon}) no-repeat top left;
                    background-size: 20px 20px;
                }
            }
            &.active {
                .icon {
                    top:8px;
                    right:8px;
                    width:20px;
                    height:20px;
                    background: url(${minusIcon}) no-repeat top left;
                    background-size: 20px 20px;
                }
            }
        }
    
    }
`;

export default withTheme(ToolNavButton);
